import {AttrsSchema, Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {DashboardOrigin, getDashboardParams} from 'common/report/util/bookmark-overrides';
import {encodeRison, serializeJsUrl} from 'common/report/util/url';
import {Section} from 'common/components/items-menu/types';
import {ReportName} from 'common/report/constants';
import {REPORT_ICONS} from 'common/report/util/boards';

import css from './index.styl?inline';
import {template} from './template';
import {AddReportButtonTheme} from './constants';

interface AddReportButtonAttrs {
  dashboard?: DashboardOrigin;
  disabled?: boolean;
  'include-new-dashboard'?: boolean;
  theme?: AddReportButtonTheme;
  tooltip?: string;
}
export class AddReportButton extends Component<EmptyObj, AddReportButtonAttrs> {
  static get attrsSchema(): AttrsSchema<AddReportButtonAttrs> {
    return {
      ...super.attrsSchema,
      dashboard: `json`,
      disabled: `boolean`,
      'include-new-dashboard': `boolean`,
      theme: {type: `string`, default: AddReportButtonTheme.Sidenav},
      tooltip: `string`,
    };
  }

  get config() {
    return {
      css,
      template,
      defaultState: {},
      useShadowDom: true,
      helpers: {
        getReportSections: (): Section[] => {
          return [
            ...(this.attr(`include-new-dashboard`)
              ? [
                  {
                    items: [
                      {
                        label: `Dashboard`,
                        icon: REPORT_ICONS[ReportName.Dashboards],
                        value: `dashboards`,
                      },
                    ],
                  },
                ]
              : []),
            {
              label: this.attr(`include-new-dashboard`) ? `Reports` : null,
              items: [
                {
                  label: `Insights`,
                  icon: REPORT_ICONS[ReportName.Insights],
                  value: `insights`,
                  href: this.getLinkWithDashboardParams(`insights`),
                },
                {
                  label: `Funnels`,
                  icon: REPORT_ICONS[ReportName.Funnels],
                  value: `funnels`,
                  href: this.getLinkWithDashboardParams(`funnels`),
                },
                {
                  label: `Flows`,
                  icon: REPORT_ICONS[ReportName.Flows],
                  value: `flows`,
                  href: this.getLinkWithDashboardParams(`flows`),
                },
                {
                  label: `Retention`,
                  icon: REPORT_ICONS[ReportName.Retention],
                  value: `retention`,
                  href: this.getLinkWithDashboardParams(`retention`),
                },
              ],
            },
          ];
        },
        handleCreateReportClicked: (ev) => {
          this.dispatchEvent(new CustomEvent(`change`, {detail: {value: ev.detail.item.value}}));
        },
        handleCreateReportSelectClicked: (ev) => {
          this.dispatchEvent(new CustomEvent(`menuChange`, ev));
        },
      },
    };
  }

  getLinkWithDashboardParams(href: string) {
    const dashboard = this.attr(`dashboard`);
    if (dashboard && `id` in dashboard && `title` in dashboard) {
      switch (href) {
        case `insights`:
        case `flows`:
          return `${href}#${serializeJsUrl(getDashboardParams(dashboard))}`;
        case `funnels`:
          return `${href}#view/${encodeRison(getDashboardParams(dashboard))}`;
        case `retention`:
          return `${href}#${encodeRison(getDashboardParams(dashboard))}`;
      }
    }
    return href;
  }
}

export const AddReportButtonEl = defineAndMakeJsxFactory(`mp-add-report-button`, AddReportButton);
